export default function CircleTick({ isCompleted = false }: { isCompleted?: boolean }) {
    return (
        <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 sm:w-6 sm:h-6">
            <circle cx="12.833" cy="12" r="11.5" fill={isCompleted ? '#112745' : 'none'} stroke="#112745" className={'transition group-hover:stroke-white'} />
            {isCompleted && (
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.5749 7.57221C19.8613 7.88462 19.8613 8.39116 19.5749 8.70358L11.33 17.698C11.015 18.0416 10.5042 18.0416 10.1892 17.698L6.09272 13.229C5.80633 12.9166 5.80633 12.4101 6.09272 12.0977C6.3791 11.7853 6.84342 11.7853 7.1298 12.0977L10.7596 16.0574L18.5378 7.57221C18.8242 7.25978 19.2885 7.25978 19.5749 7.57221Z"
                    fill="white"
                />
            )}
        </svg>
    );
}
